import { Order } from '../types';

export const sendOrderToWhatsApp = (order: Order): void => {
  const ownerPhoneNumber = '9381956301'; // Owner's WhatsApp number
  
  const message = `
🌶️ *New Order Received!* 🧄

*Customer Details:*
Name: ${order.customerName}
Phone: ${order.customerPhone}
Email: ${order.customerEmail}

*Order Details:*
Quantity: ${order.quantity} units
Message: ${order.message || 'No additional message'}
Order ID: ${order.id}
Time: ${order.timestamp.toLocaleString()}

*Product:* Homemade Pure Ginger Garlic Paste
🏠 Freshly prepared with love and care!
  `.trim();

  const whatsappUrl = `https://wa.me/${ownerPhoneNumber}?text=${encodeURIComponent(message)}`;
  
  // Open WhatsApp in a new tab
  window.open(whatsappUrl, '_blank');
};

export const formatOrderMessage = (order: Order): string => {
  return `
🌶️ *New Ginger Garlic Paste Order!* 🧄

Customer: ${order.customerName}
Phone: ${order.customerPhone}
Quantity: ${order.quantity} units
Message: ${order.message || 'None'}
Order ID: ${order.id}

Fresh Homemade Pure Ginger Garlic Paste 🏠
  `.trim();
};
